<template>
  <div class="Order">
    <Topbar title="Commande" backButton />
    <section class="Section" v-if="order">
      <div class="Order__id">N° {{ order.id }}</div>
      <OrderLine v-for="(line, index) in mergedLines" :key="index" v-bind="line" />
      <div v-if="order.delivery_address">
        <AddressCard
          class="Order__address"
          label="Adresse de livraison"
          :address="order.delivery_address"
          :canEdit="false"
        />
        <AddressCard
          v-if="user.billing_address && user.billing_address.id !== order.delivery_address.id"
          class="Order__address"
          label="Adresse de facturation"
          :address="user.billing_address"
          :canEdit="false"
        />
      </div>
      <div class="Order__footer">
        <div class="Order__total-btls">
          Soit <strong>{{ totalChargeableBtls }}</strong> {{ "bouteille" | pluralize(totalChargeableBtls) }}
          <span v-if="totalFreeBtls > 0"> + <strong>{{ totalFreeBtls }}</strong> {{ "gratuite" | pluralize(totalFreeBtls) }}</span>
        </div>
        <div class="Order__total-price">
          <label for="">Total de commande</label>
          <div class="Order__total-value">
            <Price :price="totalPrice" />
          </div>
        </div>
      </div>
      <Button class="Button--primary" v-if="order.completed" :disabled="loading" @click.native="reorder">Re-passer commande</Button>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import orderService from "../services/order";
import notificationService from "../services/notification";
import OrderLine from "../components/OrderLine";
import Button from "../components/Button";
import AddressCard from "../components/AddressCard";

export default {
  data() {
    return {
      order: null,
      loading: false
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    mergedLines() {
      return this.order.lines.reduce((acc, line) => {
        if (line.price === 0) {
          const master = this.order.lines.find(l => l.price > 0 && l.product_id === line.product_id);

          master.freeBtls = line.quantity;
        }

        return acc;
      }, this.order.lines.filter(line => line.price > 0));
    },
    totalPrice() {
      return this.order.lines.reduce((total, line) => total + line.price * line.quantity, 0);
    },
    totalChargeableBtls() {
      return this.order.lines.reduce((total, line) => total + (line.price > 0 ? line.quantity : 0), 0);
    },
    totalFreeBtls() {
      return this.order.lines.reduce((total, line) => total + (line.price === 0 ? line.quantity : 0), 0);
    }
  },
  methods: {
    reorder() {
      this.loading = true;

      this.$store.dispatch("cart/reorder", this.mergedLines)
        .then(() => {
          this.$router.replace({ name: "Cart" });
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          notificationService.error(err.message, err.errors);
        });
    }
  },
  created() {
    orderService.get(this.$route.params.id)
      .then(({ data: order }) => this.order = order);
  },
  components: {
    OrderLine,
    Button,
    AddressCard
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.Order {
  &__id {
    text-align: center;
    font-weight: 700;
    margin-bottom: $global-margin * 2;
  }

  &__footer {
    margin: $global-margin 0;
    font-size: 0.875rem;
  }

  &__total-price {
    display: flex;
    justify-content: space-between;
    align-items: center;

    label {
      font-weight: 700;
    }
  }

  &__total-value {
    font-size: 1.3125rem;
  }

  &__address {
    background: #fff;
    margin: $global-margin * 2 0;
  }
}
</style>
